import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { TieredMenu } from 'primereact/tieredmenu';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import CSVFileUpload from './CSVFileUpload';
import { API } from 'aws-amplify';
import { GetByBasePriceCSVDownload, GetByDiscountCSVDownload, GetByPriceCSVDownload } from '../../../graphql/queries';
import { showToast } from '../../ToastUtils';
import { style } from '@mui/system';
import CsvUploadButton from './ProductVisibility/CsvUploadButton';
import DownloadCsvTemplate from './ProductVisibility/DownloadCsvTemplate';


function ProductsViewOptions({ contextVariable, getFullDateTime, RowDatalength }) {

    const menu = useRef(null);
    const { t } = useTranslation();

    const [openDialog, setOpenDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState({
        label: '',
        value: '',
        folderName: '', type: ""
    });


    const getPriceListConfig = (label, icon, actionType) => ({
        label,
        icon,
        items: [
            {
                idName: 'Base price',
                label: 'Base Price',
                disabled: actionType === "upload" && contextVariable.OrganizationDetails.PriceAutoSyncIndicator,
                command: () => handleAction(actionType, 'BP', 'BasePriceList', "Base Price")
            },
            contextVariable.OrganizationDetails.AdditionalPricingOptions === 'CSD' && {
                idName: 'CSD',
                label: 'Customer Specific Discount',
                command: () => handleAction(actionType, 'CSD', 'CustomerSpecificDiscountList', "Customer Specific Discount")
            },
            contextVariable.OrganizationDetails.AdditionalPricingOptions === 'CSP' && {
                idName: 'CSP',
                label: 'Customer Specific Price',
                command: () => handleAction(actionType, 'CSP', 'CustomerSpecificPriceList', "Customer Specific Price")
            }
        ].filter(Boolean)
    });


    const getProductVisiblitityConfig = (label, icon, actionType) => ({
        label,
        icon,
        items: [
            { label: 'General Enable/Disable', command: () => handleAction(actionType, "General", "", "General Product Enable/Disable - CSV Upload/Download") },
            { label: 'Customer-Specific Restriction', command: () => handleAction(actionType, "Customer-Specific", "", "Customer-Specific Restricted Products - CSV Upload/Download") }
        ]
    })

    const handleAction = (type, value, folderName, label) => {
        if (type === 'upload') {
            handleMenuItemClick(t(label), value, folderName, type);
        } else if (type === 'download') {
            downloadCSVFromBase64(value);
        }
        else if (type === 'ProductVisibility') {
            handleMenuItemClick(t(label), value, folderName, type);
        }
    };
    const handleMenuItemClick = (label, value, folderName, type) => {
        setSelectedOption(prev => ({
            ...prev,
            label,
            value,
            folderName,
            type
        }));
        // console.log(selectedOption);
        setOpenDialog(true);
    }






    const queryMap = {
        CSP: GetByPriceCSVDownload,
        CSD: GetByDiscountCSVDownload,
        BP: GetByBasePriceCSVDownload
    };

    const downloadCSVFromBase64 = async (pricingOption) => {
        try {
            const response = await API.graphql({ query: queryMap[pricingOption] });
            const base64String = response?.data?.[Object.keys(response.data)[0]]?.base64;

            if (!base64String || base64String.includes("data is empty")) {
                return showToast("Data is empty. Please upload some prices.", 3000);
            }

            const csv = atob(base64String);
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `${pricingOption === 'CSD' ? 'Customer_Specific_Discount' : pricingOption === 'CSP' ? 'Customer_Specific_Price' : 'Base_Price'}_${getFullDateTime()}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (e) {
            console.error("Failed to decode base64 string:", e);
        }
    };



    const handleClose = () => {
        // console.log("Inside");
        setOpenDialog(false);
        setSelectedOption({ label: '', value: '', folderName: '', type: "" });
    }
    const handleLoading = () => {
        // alert("handle")
        setLoading(!loading);
    }

    const items = useMemo(() => [
        getProductVisiblitityConfig('Product Visibility', 'pi pi-eye', 'ProductVisibility'),
        getPriceListConfig('Price List Upload', 'pi pi-upload', 'upload'),
        getPriceListConfig('Price List Download', 'pi pi-download', 'download'),
    ], [contextVariable.OrganizationDetails.PriceAutoSyncIndicator, contextVariable.OrganizationDetails.AdditionalPricingOptions]);

    return (
        <>
            <TieredMenu model={items} popup ref={menu} style={{ width: '16%', fontSize: "13px" }} />
            <Button icon="pi pi-chevron-circle-down" disabled={RowDatalength > 0 ? false : true} label="Advanced Options" onClick={(e) => menu.current.toggle(e)} />

            {
                openDialog &&

                <Dialog
                    header={selectedOption.label}
                    visible
                    style={{ width: '60vw' }}
                    onHide={() => handleClose()}
                    draggable={false}
                >
                    {selectedOption.type !== "ProductVisibility" && <CSVFileUpload {...{ selectedOption, handleClose, handleLoading }} />}
                    {selectedOption.type === "ProductVisibility" && <div className={`flex gap-4 `}>
                        <div className='w-50'> <CsvUploadButton t={t} DialogName={selectedOption.value} /></div>
                        <div className='w-50'><DownloadCsvTemplate t={t} DialogName={selectedOption.value} /></div>

                    </div>}
                </Dialog>

            }

        </>
    )
}

export default ProductsViewOptions